import { constructErrorMessage } from 'utils/helpers';
import getAnalyticsObjectAU from 'utils/analytics/getAnalyticsObjectAU';
import { BANK_SCRAPING_IFRAME_STATUS, STEP_BANK_STATEMENT } from 'consts/loan/AU';
import { GTM_EVENT_NAMES } from 'consts/gtmEvents';
import { PROVISO_MOCK_URL } from 'consts';
import * as actionTypes from '../actionTypes';
import { goToNextPage } from '../loan';
import putLog from '../putLog';
import { track } from '../analytics';
import { resetBankScrapingResult } from './resetBankScrapingResult';

// Loading guard to prevent duplicate API calls during async operations.
// Using an object as a mutable container while keeping the reference immutable.
// Note: This workaround will be handled more elegantly in the new repository architecture.
const loadingState = { isLoading: false };

const HTTP_STATUS_CONFLICT = 409;

export function getProvisoUrl() {
  if (loadingState.isLoading) {
    return { type: 'PROVISO_URL_DUPLICATE_CALL_BLOCKED' };
  }

  loadingState.isLoading = true;

  return {
    types: [
      actionTypes.GET_PROVISO_IFRAME_URL,
      actionTypes.GET_PROVISO_IFRAME_URL_SUCCESS,
      actionTypes.GET_PROVISO_IFRAME_URL_FAIL,
    ],
    promise: (client) => client.get(
      `${API_HOST}/credit-application-au/initialise-proviso?redirect_url=${window.location.origin}${window.location.pathname}`,
      { hideError: true }
    ).finally(() => {
      loadingState.isLoading = false;
    }),
    afterSuccess: (dispatch, getState, response) => {
      const { data: { iframeUrl } } = response;
      const isProvisoMock = iframeUrl === PROVISO_MOCK_URL;

      dispatch(track(GTM_EVENT_NAMES.PROVISO_STATUS, {
        analyticsAU: (storeState) => getAnalyticsObjectAU(
          STEP_BANK_STATEMENT.type,
          storeState,
          { provisoStatus: BANK_SCRAPING_IFRAME_STATUS.IFRAME_LOADED }
        ),
      }));

      if (isProvisoMock) {
        dispatch(goToNextPage());
      }
    },
    afterFailure: (dispatch, getState, response) => {
      const isConflictStatus = response.status === HTTP_STATUS_CONFLICT;

      if (isConflictStatus) {
        dispatch(resetBankScrapingResult());
        dispatch(goToNextPage());
        return;
      }

      dispatch(track(GTM_EVENT_NAMES.PROVISO_STATUS, {
        analyticsAU: (storeState) => getAnalyticsObjectAU(
          STEP_BANK_STATEMENT.type,
          storeState,
          { provisoStatus: BANK_SCRAPING_IFRAME_STATUS.IFRAME_LOAD_FAIL }
        ),
      }));

      const { authentication: { id } } = getState();
      const message = constructErrorMessage(id, response);
      dispatch(putLog(message, 'error'));
    },
  };
}
